export function trackUiEvent(name, detail = {}) {
  if (typeof window === "undefined") return;

  const payload = {
    name,
    ...detail,
    ts: new Date().toISOString(),
  };

  window.dispatchEvent(new CustomEvent("analytics:event", { detail: payload }));

  // TODO: replace this hook with the product analytics provider once one is adopted.
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[analytics:event]", payload);
  }
}
